webpackJsonp([198],{

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX 源码本地运行 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1972:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1157),
  /* template */
  __webpack_require__(2049),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/vux-development-277.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vux-development-277.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1477dbf4", Component.options)
  } else {
    hotAPI.reload("data-v-1477dbf4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2049:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 源码本地运行")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("phantomjs 可能会遇到无法下载的问题，建议先用 cnpm 全局安装")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("本地查看文档")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', [_vm._v("文档相关命令")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("docs 目录下的相关命令，它们是 npm run doc:build 的一部分，但是可以单独运行")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', [_vm._v("构建部分文档")]), _vm._v(" "), _c('p', [_vm._v("文档页面比较多等待 build 命令会长，因此可以只构建部分文档方便快速查看。")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', [_vm._v("官网文档部署说明")]), _vm._v(" "), _vm._m(6)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("cnpm install -g phantomjs-prebuilt\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("请更新 "), _c('code', [_vm._v("NodeJS")]), _vm._v(" 版本到 "), _c('code', [_vm._v("v7.6.0")]), _vm._v(" 以上，"), _c('code', [_vm._v("build")]), _vm._v(" 命令逐步使用 "), _c('code', [_vm._v("async")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("yarn "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("# 使用 yarn.lock 保证依赖版本一致")]), _vm._v("\nyarn dev "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("# 或者 npm run dev")]), _vm._v("\n\n\nyarn dev -- --env.include datetime,alert "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("# 只运行部分组件，耗时短")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm run doc:build // 构建文档\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("cd")]), _vm._v(" docs\nyarn\nnpm run dev // 耗时较长\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("node compile // 生成文档路由\nnode component-contributions // 从 git 记录里获取每个组件提交历史\n\nnpm run doc:dev // 运行\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("cd")]), _vm._v(" docs\nnode compile --include datetime // 只构建 datetime 相关文档，多个时以英文逗号分隔，如：datetime,alert\nnpm run dev\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("线上页面有 "), _c('code', [_vm._v("30分钟")]), _vm._v(" 页面缓存，定时每 "), _c('code', [_vm._v("20分钟")]), _vm._v(" 构建一次，因此提交后可能会需要 "), _c('code', [_vm._v("1小时")]), _vm._v(" 才会更新到官网。")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1477dbf4", module.exports)
  }
}

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1972);

/***/ })

});


// WEBPACK FOOTER //
// 198.3d4e7182.js